export default "__VITE_ASSET__a5fc1f12__"